export const categoriesKeyById = state => state.categories.reduce((carry, item) => {
    carry[item.id] = item;
    return carry;
}, {})